import { axiosInstance } from 'lib/axios'
import React from 'react'
import { searchAPI } from 'services/apis.service'

const fetchRelatedSearchService = async (search) => {
  const { data } = await axiosInstance.post(searchAPI.getRelatedSearch, {
    search_query: search,
  });
  return data;
};

export default fetchRelatedSearchService;